import React from 'react'
import IconButton from '../IconButton'
import { MdClose } from 'react-icons/md'

const CloseButton = (props) => {
  return <IconButton {...props} icon={<MdClose />} />
}

export default CloseButton
